import React, { ReactElement, MouseEventHandler } from 'react'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { makeStyles } from '@material-ui/core/styles'

export interface CloseButtonProps {
  hidden?: boolean
  onClick: MouseEventHandler
}

const useStyles = makeStyles(() => ({
  button: {
    '@media print': {
      visibility: 'hidden'
    }
  }
}))

function CloseButton({ hidden, onClick }: CloseButtonProps): ReactElement {
  const classes = useStyles()
  if (hidden) return null
  return (
    <IconButton
      className={classes.button}
      onClick={onClick}
      aria-label="close-help"
      color="inherit">
      <CloseIcon />
    </IconButton>
  )
}

export default CloseButton
